import { Snackbar ,Paper, Typography } from '@mui/material';

const SnackBarComponent = ({snackbarOpen, snackBarMessage, handleSnackbarClose }) => {

    return(
        <Snackbar
                open={snackbarOpen}
                onClose={handleSnackbarClose}
                autoHideDuration={3000}
                anchorOrigin={{horizontal:'center', vertical:'bottom'}}
            >
                <Paper sx={{padding: '15px 40px'}}>
                    <Typography className='_wg-dynamic-text' align='center'>{snackBarMessage}</Typography>
                </Paper>
            </Snackbar>
    )
}

export default SnackBarComponent;